<template>
  <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
    <wt-form-table-list ref="siteManageTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      <template slot="isPublish" slot-scope="data">
        <span>{{ data.row.isPublish === 1 ? '正常' : '禁用' }}</span>
      </template>
<!--      <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
         <wt-auth v-if="scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
           <el-button size="mini" type="primary" @click="toClickAction(scope.row)">禁用</el-button>
         </wt-auth>
         <wt-auth v-if="!scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
           <el-button size="mini" type="primary" @click="toClickAction(scope.row)">启用</el-button>
         </wt-auth>
      </template> -->
    </wt-form-table-list>
  </wt-form-table>
</template>

<script>
export default {
  name: 'AllSiteList',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_INDEX',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteNoOrgList' },
          delete: { type: 'default', value: '/modules/site/siteDelete' },
          add: {
            type: 'component', componentName: 'SiteIndexEditPage', value: 'resetSiteDetailData', detailData: {}},
          edit: {
            type: 'component', componentName: 'SiteIndexEditPage', value: 'setSiteDetailData', detailData: {}},
          view: {
            type: 'component', componentName: 'SiteIndexViewPage', value: 'setSiteDetailData', detailData: {}}
        },
        formInputsData: [
          { name: '站点名称', key: 'name', value: '', type: 'text' }],
        formButtonsData: [],
        // { name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
        // { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '社区名称', key: 'communityName', type: 'text' },
          { name: '物业总名称', key: 'name1', type: 'text' },
          { name: '物业分名称', key: 'name2', type: 'text' },
          { name: '项目部', key: 'name3', type: 'text' },
          { name: '站点位置', key: 'address', type: 'text' }],
        // { name: '状态', key: 'isPublish', type: 'custom' }],
        // { name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
        formTableButtonsData: [
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 190 }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  methods: {
    onButtonAction(data) {
      if (data.item.action === 'EDIT') {
        this.form.formComponent.edit.detailData = {
          row: data.row,
          parent: null
        }
      }
    },
    toClickAction(row, type) {
      const that = this
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认禁用？' : '确认启用？').then(() => {
        that.$api.siteManage.site.siteIsPublish({
          id: row.id
        }).then(res => {
          that.$message({ message: '操作成功', type: 'success' })
          that.$refs.siteManageTableRef.requestList()
        })
      })
    }
  }
}
</script>

<style>
</style>
